const popupStyles = {
    closeButton: {
      position: "absolute",
      left: 8,
      top: "50%",
      transform: "translateY(-50%)",
      minWidth: "32px",
      height: "32px",
      padding: 0,
      fontSize: "1.2rem",
      lineHeight: 1,
      color: "#888",
      fontWeight: "bold",
      borderRadius: "50%",
      background: "transparent",
      cursor: "pointer",
    },
  
    recentActionBox: {
      marginTop: 8,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
  
    recentActionTitle: {
      color: "red",
      fontWeight: "bold",
      fontSize: "1rem",
    },
  
    recentActionSubtitle: {
      color: "black",
      fontSize: "0.85rem",
      marginTop: 4,
    },
  
    textFieldBox: {
      direction: "rtl",
      textAlign: "right",
      marginTop: 16,
    },
  
    textFieldInput: {
      textAlign: "right",
    },
  };
  
  export default popupStyles;
  